import {
  DEFAULT_API_BASE,
  DEFAULT_REPORT_API_BASE,
  isLocalEndpoint,
} from "../../../config";

/**
 * base URL ของ API ทั้งหมด อ่านจาก runtimeConfig.public (ตั้งค่าที่ nuxt.config.ts)
 *
 * DataService ถูก new ตั้งแต่ตอน import โมดูล ซึ่งบางจังหวะยังไม่มี Nuxt context
 * useRuntimeConfig() จะ throw จึงต้องมี fallback ไว้เสมอ ห้ามปล่อยให้ระเบิด
 */
export const useBaseUrl = function (type = "core") {
  const fallback = type === "report" ? DEFAULT_REPORT_API_BASE : DEFAULT_API_BASE;

  try {
    const config = useRuntimeConfig();
    // report service คนละ host กับ core API ห้าม fallback ข้ามกัน ไม่งั้นยิงผิดตัว
    const base =
      type === "report" ? config.public.reportApiBase : config.public.apiBase;

    // ด่านสุดท้าย: ถ้ามี build ที่ฝัง localhost หลุดขึ้น hosting ไปแล้ว
    // อย่างน้อยเบราว์เซอร์ที่ไม่ได้เปิดจาก localhost จะไม่ยิงไปที่เครื่องตัวเอง
    if (base && isLocalEndpoint(base as string) && !isServedFromLocalhost()) {
      console.warn(
        `[useBaseUrl] ข้าม endpoint "${base}" เพราะเป็น localhost แต่หน้าเว็บไม่ได้เปิดจากเครื่องตัวเอง ใช้ ${fallback} แทน`
      );
      return fallback;
    }

    if (base) return base as string;
  } catch {
    // ไม่มี Nuxt context (module scope / นอก app) ตกไปใช้ค่า default
  }

  return fallback;
};

/** หน้าเว็บถูกเปิดจากเครื่องตัวเองหรือไม่ (nuxt dev / nuxt preview) */
const isServedFromLocalhost = () =>
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\])$/i.test(
    window.location.hostname
  );
